export default "/assets/images/technology-hero-sm.eb1d149408aeb405.webp";